module.exports = __webpack_public_path__ + "static/img/fz_xe_what.c4d4fb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_xe_what.png
// module id = FXw2
// module chunks = 0